__turbopack_context__.v({
  "black": "styles-module-scss-module__K5eKza__black",
  "icon": "styles-module-scss-module__K5eKza__icon",
  "root": "styles-module-scss-module__K5eKza__root",
  "white": "styles-module-scss-module__K5eKza__white",
});
